import { Box, Grid, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import SumOfAmountByDate from "../../components/Reports/SumOfAmountByDate";
import Pie from "../../components/Incidents/charts/Pie";
import ReportsPieChart from "../../components/Reports/ReportsPieChart";
import FilterReports from "../../components/Reports/FilterReports";

const CustomBox = styled(Box)(({ theme }) => ({
  "&.MuiBox-root": {
    padding: "16px",
    border: "1px solid #E1E1E1",
    paddingTop: "12px",
    paddingRight: "16px",
    paddingBottom: "20px",
    paddingLeft: "16px",
    borderRadius: "8px",
    "& h5": {
      fontSize: "20px",
      fontWeight: 700,
      marginBottom: "16px",
    },
  },
}));

const chartsData = [
  { date: "2024-09-29", amount: 12039.11 },
  { date: "2024-09-22", amount: 79127.74 },
  { date: "2024-09-15", amount: 78954.96 },
  { date: "2024-09-08", amount: 73202.54 },
  { date: "2024-09-01", amount: 71319.81 },
  { date: "2024-08-25", amount: 91926.04 },
  { date: "2024-08-18", amount: 85450.22 },
  { date: "2024-08-11", amount: 98217.76 },
  { date: "2024-08-04", amount: 88431.62 },
  { date: "2024-07-28", amount: 92835.29 },
  { date: "2024-07-21", amount: 98764.41 },
  { date: "2024-07-14", amount: 85084.64 },
  { date: "2024-07-07", amount: 91105.47 },
  { date: "2024-06-30", amount: 80758.98 },
  { date: "2024-06-23", amount: 83951.8 },
  { date: "2024-06-16", amount: 80156.16 },
  { date: "2024-06-09", amount: 71678.85 },
  { date: "2024-06-02", amount: 76584.51 },
  { date: "2024-05-26", amount: 70631.94 },
  { date: "2024-05-19", amount: 75197.94 },
  { date: "2024-05-12", amount: 75199.54 },
  { date: "2024-05-05", amount: 77715.71 },
  { date: "2024-04-28", amount: 68357.62 },
  { date: "2024-04-21", amount: 63488.34 },
  { date: "2024-04-14", amount: 74686.79 },
  { date: "2024-04-07", amount: 59211.78 },
  { date: "2024-03-31", amount: 54268.49 },
  { date: "2024-03-24", amount: 62911.34 },
  { date: "2024-03-17", amount: 52541.19 },
  { date: "2024-03-10", amount: 51022.51 },
  { date: "2024-03-03", amount: 56863.38 },
  { date: "2024-02-25", amount: 48435.14 },
  { date: "2024-02-18", amount: 59136.22 },
  { date: "2024-02-11", amount: 59854.86 },
  { date: "2024-02-04", amount: 64299.81 },
];

const amountReasonData = [
  { label: "Vacation", value: 2738101.84 },
  { label: "Injured", value: 1642758.97 },
  { label: "Sick (Self)", value: 1123418.12 },
  { label: "Open Position", value: 958964.08 },
  { label: "Administrative Duties", value: 796681.46 },
  { label: "Sick (Family)", value: 613650.93 },
  { label: "Detail", value: 187115.95 },
  { label: "Light Duty", value: 143056.6 },
  { label: "Administrative Leave", value: 130788.14 },
  { label: "Union Business", value: 94895.61 },
  { label: "Funeral Leave", value: 76382.5 },
  { label: "Military Leave", value: 75184.8 },
  { label: "Late Relief", value: 60375.06 },
  { label: "Training", value: 51670.42 },
  { label: "Miscellaneous", value: 42513.26 },
  { label: "Late Call", value: 36104.45 },
  { label: "BIrddog", value: 23977.03 },
  { label: "Department Business", value: 11327.73 },
  { label: "Reassigned", value: 10384.62 },
  { label: "Training EMS", value: 10340.82 },
  { label: "Training Fire", value: 8094.78 },
  { label: "Fire Alarm", value: 2227.2 },
  { label: "Meeting", value: 1608.82 },
  { label: "Fire Watch at FedEx", value: 819.42 },
  { label: "Holdover", value: 660.34 },
  { label: "Back step Fire Alarm", value: 604.66 },
  { label: "Fire Watch At FedEx", value: 585.3 },
];

const amountByPayCodeData = [
  { label: "FF1OT", value: 2968748 },
  { label: "LTOT", value: 2643529.41 },
  { label: "CPTOT", value: 1212652.17 },
  { label: "BCOT", value: 1078131.84 },
  { label: "FF3OT", value: 479193.05 },
  { label: "FF4OT", value: 192183.77 },
  { label: "ACOT", value: 141174.36 },
  { label: "FF2OT", value: 101688.0 },
  { label: "NCD", value: 24992.31 },
];

const SummaryData = () => {
  return (
    <Grid container spacing={2} className="my-2">
      <Grid item xs={12} className="d-flex justify-content-end">
        <FilterReports />
      </Grid>
      <Grid item xs={12}>
        <Box>
          <Grid container spacing={2} className="my-2">
            <Grid item xs={12}>
              <CustomBox>
                <Typography variant="h5">Sum of Amount by Date</Typography>
                <SumOfAmountByDate data={chartsData} />
              </CustomBox>
            </Grid>
            <Grid item xs={12} md={6}>
              <CustomBox>
                <Typography variant="h5">Amount by Reason</Typography>
                <ReportsPieChart data={amountReasonData} />
              </CustomBox>
            </Grid>
            <Grid item xs={12} md={6}>
              <CustomBox>
                <Typography variant="h5">Amount by Pay Code</Typography>
                <ReportsPieChart data={amountByPayCodeData} />
              </CustomBox>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
};

export default SummaryData;
